import React from 'react';
import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import Loadingcomponent from '../loader/loadingcomponent';
import NojoomDashboardStats from './nojoom-dashboard-stats';
import NojoomDashboardStatus from './nojoom-dashboard-status';
import {
  setNojoomDashboardMsisdnData,
  setNojoomDashboardMessageData,
} from '../../reducer/nojoomSlice';
import {setNojoomRewardPoints,setNojoomMemberNumber,setNojoomPrimaryNumber} from '../../reducer/actions'
import NojoomDashboardStatusShimmer from '../../ShimmerEffect/NojoomDashboardStatus-shimmer';

const NojoomDashboard = ({ pmsitem }) => {
  const dispatch = useDispatch();

  const { data: { data } = {}, isLoading, isFetching } = useQuery(
    ['nojoom_dashboard', pmsitem?.method, JSON.parse(pmsitem?.sourceid), {}],
    {
      retry: false,
      retryOnMount: false,
      cacheTime: 0,
      staleTime: 0,
      onSuccess: ({ data: resData }) => {
        const nojoomDashboardMsisdnData =
          resData?.response?.ListOfMSISDNLoyMember?.length > 0
            ? resData?.response?.ListOfMSISDNLoyMember[0]
            : null;
        const nojoomDashboardMessageData = resData?.response?.Messages || null;

       try{
if(nojoomDashboardMsisdnData != null && nojoomDashboardMsisdnData != undefined && nojoomDashboardMsisdnData != ""
){
  dispatch(setNojoomRewardPoints(nojoomDashboardMsisdnData?.RewardPoints));
  dispatch(setNojoomMemberNumber(nojoomDashboardMsisdnData?.MemberNumber));
  dispatch(setNojoomPrimaryNumber(resData?.response?.PrimaryMsisdn))
}
       }catch(e){}

        dispatch(setNojoomDashboardMsisdnData(nojoomDashboardMsisdnData));
        dispatch(setNojoomDashboardMessageData(nojoomDashboardMessageData));
      },
    }
  );

  if (isLoading || isFetching) {
    return (
     <NojoomDashboardStatusShimmer/>
    );
  }

  return (
    // <div class="pse_sm banner-bg-gray-h240">
    //   {isLoading ? (
    //     <Loadingcomponent />
    //   ) : (
    //     <>
    //       <NojoomDashboardStats data={data} />
    //       <NojoomDashboardStatus data={data} />
    //     </>
    //   )}
    // </div>

    <>
      {data?.status !== '-1' && (
        <div className="pse_sm">
          <NojoomDashboardStatus data={data} />
          <NojoomDashboardStats data={data} />
        </div>
      )}
    </>
  );
};

export default NojoomDashboard;
